interface PageHeadlineProps {
    children: React.ReactNode;
}

const PageHeadline = (props: PageHeadlineProps) => {
    return <h1 className={'grow text-xl font-semibold text-foreground'}>{props.children}</h1>;
};

export default PageHeadline;
